import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import type { RootState } from "../app/store";
import { API_URL } from "../constants/url";
import { getFromStorage, STORAGE_KEYS } from "../constants";
import { resetAuth } from "../reducers/authSlice";
import { generateSEKAndHash } from "./crypto";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState }) => {
    const { token, tempToken } = (getState() as RootState).auth;
    const storedToken = getFromStorage(STORAGE_KEYS.token) as string | null;
    const authToken = token || tempToken || storedToken;

    const encryptData = generateSEKAndHash(authToken || null);

    if (encryptData) {
      headers.set("hash", encryptData?.hash);
      headers.set("sek", encryptData?.sek);
    }

    headers.set("deviceType", "web");

    console.log(headers, "--------");

    // if (token) {
    //   headers.set("authorization", `Bearer ${token}`);
    // } else if (tempToken) {
    //   headers.set("authorization", `Bearer ${tempToken}`);
    // }
    // headers.set("Hash", `${encryptedData?.hash}`);
    // headers.set("Sek", ` ${encryptedData?.sek}`);
    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs | any,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  // Log Request
  const requestUrl = typeof args === 'string' ? args : args.url;
  const requestMethod = typeof args === 'string' ? 'GET' : (args.method || 'GET');
  const requestBody = typeof args === 'string' ? null : args.body;
  
  console.log('🚀 API REQUEST:', {
    url: `${API_URL}${requestUrl}`,
    method: requestMethod,
    body: requestBody,
    fullArgs: args
  });

  // if (args.body) {
  //   const encryptedData = generateEncryptedKeyBody(args.body);
  //   if (encryptedData) {
  //     args.body = encryptedData;
  //   } else {
  //     return {
  //       error: {
  //         status: 400,
  //         data: { detail: "Failed to encrypt request body" },
  //       },
  //     };
  //   }
  // }
  const result = await baseQuery(args, api, extraOptions);

  // Log Response
  console.log('✅ API RESPONSE:', {
    url: `${API_URL}${requestUrl}`,
    method: requestMethod,
    status: result.error ? result.error.status : 'success',
    data: result.data,
    error: result.error
  });
  //   if (result.error?.status === 400) {
  //     const errors = Object.values(result?.error?.data || {});
  //     console.log({ errors });
  //     if (errors?.length > 1 && errors[1] === 400) {
  //       return result;
  //     }

  //     if (errors?.length) {
  //       const error = errors[0] as any;
  //       if (error?.length) {
  //         console.log(error[0]);
  //       }
  //     }
  //   }
  if (result?.error?.status === 401) {
    api.dispatch(resetAuth());
    if (window) {
      window.location.replace("/");
    }
  }
  if (
    result.error &&
    result.error.status === 401 &&
    (api.getState() as RootState).auth.user
  ) {
    api.dispatch(resetAuth());
  }

  return result;
};

const emptySplitApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: ["UNAUTHORIZED", "UNKNOWN_ERROR"],
  endpoints: () => ({}),
});

export default emptySplitApi;
